export interface GetFiltersAction {
  type: 'API/GET_FILTERS';
}

export function getFilters(): GetFiltersAction {
  return {
    type: 'API/GET_FILTERS',
  };
}
